'use client';

import { Children, useState } from 'react';
import { ToggleButton } from 'components/controls/buttons/toggle-button';
import styles from './load-more-wrapper.module.scss';

export default function LoadMoreWrapper<Container>({
	children,
	initialCount = 10,
	amountToAdd = initialCount,
	showCount = true,
	Container = 'div',
	message = 'Load more',
	...restProps
}: IProps<Container>) {
	const [itemsToShow, setItemsToShow] = useState(initialCount);
	const handleClick = () => setItemsToShow(itemsToShow + amountToAdd);

	const childrenArray = Children.toArray(children);
	if (childrenArray?.length <= itemsToShow) {
		return <Container {...restProps}>{childrenArray}</Container>;
	}

	return (
		<>
			<Container {...restProps}>
				{childrenArray.slice(0, itemsToShow)}
			</Container>
			<div className={styles.controls}>
				<div className={styles.helperText}>
					{showCount && `Showing ${itemsToShow} of ${childrenArray.length}`}
				</div>
				<ToggleButton tabIndex={0} text={message} onClick={handleClick} />
			</div>
		</>
	);
}

interface IProps<Container> extends React.HTMLAttributes<HTMLElement> {
	children: React.ReactNode;
	showCount?: boolean;
	initialCount?: number;
	amountToAdd?: number;
	Container?: React.ElementType;
	message?: string;
	className?: string;
	restProps?: Container;
}
